import NavItem from '../NavItem';
import { Outlet, useNavigate } from 'react-router-dom';
import React, { FC } from 'react';
import { MenuItem } from '@/features/layout/types/layout.types';
import Logo from '../../Logo/Logo';
import ROUTES from '@/routers/Routes';

interface HeaderDesktopDisplayProps {
  modeMenuOptions: MenuItem[];
}

const HeaderDesktopDisplay: FC<HeaderDesktopDisplayProps> = ({ modeMenuOptions }) => {
  const comingSoonItems = modeMenuOptions.filter((item) => item.comingSoon);
  const navigate = useNavigate();
  const goToLobby = () => navigate(ROUTES.LOBBY);

  const firstElement = modeMenuOptions[0];
  const lastElement = modeMenuOptions[modeMenuOptions.length - 1];

  return (
    <div className="w-full min-w-[952px]">
      <header className="flex h-16 w-full items-center justify-start px-10 pb-4 pt-8">
        <div className="cursor-pointer" onClick={goToLobby}>
          <Logo />
        </div>
        <nav className="relative ml-8 mr-auto flex items-center gap-8">
          <NavItem
            comingSoon={false}
            onClick={firstElement.onClick}
            title={firstElement.title}
            Icon={firstElement.Icon}
            selected
          />

          <fieldset className="mb-2 rounded-lg border-[1px] border-ph-orange-burned px-4 pb-3 pt-1">
            <div className="flex items-center justify-start space-x-8">
              {comingSoonItems.map(({ title, Icon, onClick, comingSoon }) => (
                <NavItem
                  comingSoon={comingSoon}
                  onClick={onClick}
                  key={title}
                  title={title}
                  Icon={Icon}
                  selected={false}
                />
              ))}
            </div>
            <legend className="text-xxs mx-auto px-2 text-sm font-bold text-ph-orange-burned">COMING SOON</legend>
          </fieldset>
          <NavItem
            comingSoon={false}
            onClick={lastElement.onClick}
            title={lastElement.title}
            Icon={lastElement.Icon}
            selected={false}
          />
        </nav>
      </header>
      <Outlet />
    </div>
  );
};

export default HeaderDesktopDisplay;
